import { useEffect, useState } from "react";
import api from "@/lib/apiClient";

// Fetches a protected image as a blob and renders it, since <img> cannot send auth cookies reliably cross-origin.
export function AuthImage({ path, alt, className, onClick }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoked = false;
    let url = null;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (revoked) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      } catch (e) {
        setFailed(true);
      }
    })();
    return () => {
      revoked = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (failed)
    return (
      <div className={`flex items-center justify-center bg-zinc-100 dark:bg-zinc-800 text-zinc-400 text-xs ${className}`}>
        unavailable
      </div>
    );
  if (!src)
    return <div className={`animate-pulse bg-zinc-100 dark:bg-zinc-800 ${className}`} />;
  return <img src={src} alt={alt} className={className} onClick={onClick} onError={() => setFailed(true)} />;
}
